export enum RequirementType_Enum
{
    Customer = 1,
    Dealer = 2,
    Finance = 3,
    Internal = 4,
    SignedFinance = 5,
    InternalLender = 6,
    FurtherSecurityChecks = 7
}